import PropTypes from 'prop-types';
import React from 'react';

import { Button } from 'twyne-new.ui';

import HeaderContainerGrid from '@/components/headerContainer/Grid';
import { HeaderActions, HeaderSeparator, ReportDatePicker, RunButton } from '@/components/reports/header';

const propTypes = {
  onClickFilter: PropTypes.func,
  onChangeDates: PropTypes.func,
  onClickExport: PropTypes.func,
  dates: PropTypes.object,
  sync: PropTypes.func,
  isLoading: PropTypes.bool,
};

function ReportsProgressionHeader({ onChangeDates, dates, onClickExport, sync, isLoading, children }) {
  return <>
    <Title>
      <ReportDatePicker dates={dates} onChange={onChangeDates} />
      <HeaderSeparator />
      {children}
      <Button size="lg" variant='outline' onClick={onClickExport} >Export</Button>
      <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
    </Title>
  </>
}

const Title = ({ children }) => <>
  <HeaderContainerGrid title='Progression Report'>
    <HeaderActions>
      {children}
    </HeaderActions>
  </HeaderContainerGrid>
</>

ReportsProgressionHeader.propTypes = propTypes;

export default ReportsProgressionHeader;
